import { render, staticRenderFns } from "./LexinKeyboardLangThs.vue?vue&type=template&id=246d4a1c&"
import script from "./LexinKeyboardLangThs.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangThs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports